import React from 'react';

/**
 * Selo flutuante sobre o mapa com o rótulo da camada que está carregando.
 * Ver `features/layerLoading.js` para a pilha de rótulos que o alimenta.
 *
 * @param {{labels: string[]}} props
 */
const LayerLoadingIndicator = ({ labels }) => {
    if (!labels || labels.length === 0) return null;

    return (
        <div className="mapbox-layer-loading" role="status">
            <i className="fa fa-spin fa-spinner"></i>
            {labels[labels.length - 1]}
        </div>
    );
};

export default LayerLoadingIndicator;
